const processEnv: any = {
  ...process.env,
  ...((window as any).AppSettings || {}),
};

export const AppSettings = {
  APP_API_URL: processEnv.REACT_APP_API_URL,
};
